import { render } from "./CalibrationComponent.vue?vue&type=template&id=dd2baef0&scoped=true"
import script from "./CalibrationComponent.vue?vue&type=script&lang=js"
export * from "./CalibrationComponent.vue?vue&type=script&lang=js"

import "./CalibrationComponent.vue?vue&type=style&index=0&id=dd2baef0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2baef0"]])

export default __exports__